import './mods/material-ui'
import './mods/react-query/client'
import './mods/media-breakpoints-fresnel'
import '../src/extensions/client/createClientReactQueryClient'
import '../src/extensions/client/reactQueryRewire'
export default null
